import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
} from 'reactstrap';
 
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
 
const StandaloneGA4Settings = ({
  standalonePage,
  pageSettings,
  saveIntegration,
}) => {
  const [enabled, setEnabled] = useState(false);
  const [ga4Id, setGa4Id] = useState('');
  const [error, setError] = useState('');
 
  useEffect(() => {
    setEnabled(pageSettings?.isGa4Enabled || false);
    setGa4Id(pageSettings?.ga4Id || '');
  }, [pageSettings]);
 
  // GA4 validation
  // valid format => G-XXXXXXXXXX
  const showError = (message) => {
  setError(message);
};
  const validateGA4Id = (id) => {
    const regex = /^G-[A-Z0-9]{6,12}$/i;
    return regex.test(id);
  };
 
 
  const updateGa4Enabled = (checked) => {
    setEnabled(checked);
    setError('');
  };
 
  const updateGa4Id = (e) => {
    setGa4Id(e.target.value);
    setError('');
  };
 
  const handleSave = () => {
    const trimmedId = ga4Id.trim();
 
    /**
     * CASE 1
     * Switch OFF + Empty GA4 ID
     * => No API call
     */
    if (!enabled && !trimmedId) {
      showError(
        'Enable Google Analytics or add a valid GA4 Measurement ID to continue.'
      );
      return;
    }
 
    /**
     * CASE 2
     * Switch ON but GA4 empty
     * => Block API call
     */
    if (enabled && !trimmedId) {
      showError(
        'GA4 Measurement ID is required when Google Analytics is enabled.'
      );
      return;
    }
 
    /**
     * CASE 3
     * User entered invalid GA4 ID
     */
    if (trimmedId && !validateGA4Id(trimmedId)) {
      showError(
        'Invalid GA4 Measurement ID. Example format: G-ABCD123456'
      );
      return;
    }
 
    // clear error
   
 
    // API CALL
    saveIntegration({
      ...standalonePage,
      pageSettings: {
        ...pageSettings,
        isGa4Enabled: enabled,
        ga4Id: trimmedId,
      },
    });
  };
 
  return (
    <Card>
      <CardBody>
        <h2 className="mb-4">Google Analytics Tracking</h2>
 
        <p className="text-muted mb-4">
          Turn on Google Analytics and add your GA4 Measurement ID to track
          Digital Compendium clicks, QR scans, and user engagement in your GA
          dashboard.
        </p>
 
        <FormGroup>
          <Colxx md="12" className="mb-4 d-flex align-items-center">
            <Switch
              className="agentswitch custom-switch-primary custom-switch-small"
              checked={enabled}
              onChange={updateGa4Enabled}
            />
 
            <div className="ml-3">
              <p className="mb-0" style={{ fontWeight: 600 }}>
                Enable Google Analytics
              </p>
            </div>
          </Colxx>
 
          <Label>GA4 ID</Label>
 
          <Input
            type="text"
            placeholder="G-XXXXXXXXXX"
            value={ga4Id}
            onChange={updateGa4Id}
          />
 
          {/* ERROR MESSAGE */}
          {error && (
            <div
              className="mt-2 px-3 py-2"
              style={{
                background: '#fff3cd',
                border: '1px solid #ffeeba',
                borderRadius: '8px',
                color: '#856404',
                fontSize: '14px',
                fontWeight: 500,
              }}
            >
              {error}
            </div>
          )}
 
          <Button
            color="primary"
            className="mt-4"
            onClick={handleSave}
          >
            Save
          </Button>
        </FormGroup>
      </CardBody>
    </Card>
  );
};
 
export default StandaloneGA4Settings;
 